import { colors } from '@atlaskit/theme';
import styled from 'styled-components';

import { onMobile } from '../../mobile/responsive';

export const ProductContainer = styled.div`
  display: flex;
  margin: 0 -8px 16px;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 132px;
  & > a {
    ${onMobile(`
      margin-bottom: 12px;
    `)}
  }
`;

export const RowHeaderAction = styled.div`
  justify-self: flex-end;
`;

export const RowSubHeader = styled.div`
  margin-left: 16px;
  font-size: 12px;
  color: ${colors.N100};
`;
